import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from 'react-redux';
import { exibeMensagemSucesso, exibeMensagemErro, limpaMensagem } from "../../providers/actions";
import { mostraAguardando, escondeAguardando } from "../../providers/actions";
import { Message } from "../Message/Message";
import { Loading } from "../Loading/Loading";
import { getMessagemErro } from "../../utils/erro";
import api from "../../services/api";
import { SolicitacaoArquivoGrandesVolumesAttachmentsAndHistory } from "./AttachmentsAndHistory";
import { ArquivoGrandesVolumesDetails } from "./Details";
import { SecureDirectoryConfiguration } from "../SecureDirectory/SecureDirectoryConfiguration";

const mapDispatchToProps = { exibeMensagemSucesso, exibeMensagemErro, limpaMensagem, mostraAguardando, escondeAguardando }

const mapStateToProps = (state) => {
	return {
		user: state.usuarioStore.user,
	}
}

export const PastaSeguraProgress =

withRouter(

// redux
connect(
	(mapStateToProps), 
	(mapDispatchToProps)
)(

	class extends Component {

		constructor(props){
			super(props);
			this.state = {
                solicitacao: {
					id: undefined,
					cedenteDosDados: undefined,
					esferasAdministrativas: [],
					cpfDirigenteTi: '',
					cpfResponsavelTecnico: '',
					titulo: "",
					descricao: "",
					arquivos: [],
					justificativa: '',
					nomePastaSegura: '',
					andamentoImplantacao: '',
					dataConclusaoImplantacao: '',
                    implantacaoConcluida: false,
				},
				botoesHabilitados: true,
			};
			this.alterarSolicitacao = this.alterarSolicitacao.bind(this);
			this.concluirSolicitacao = this.concluirSolicitacao.bind(this);
		}

		componentDidMount(){
            this.props.limpaMensagem();
			const id = this.props.match.params.id;
			this.props.mostraAguardando();

			api.get(`/api/solicitacao-cadastro-arquivo-gv/${id}`)
				.then(response => { 
					const solicitacao = response.data;
					this.setState({ solicitacao: {
                        ...solicitacao,
                    }, executouCarregamento: true }) 
				})
				.catch(erro => {
					const msg = getMessagemErro("Não foi possível recuperar a solicitação de adesão.", erro);
					console.log(JSON.stringify(msg));
					this.props.exibeMensagemErro(msg.mensagem, msg.erros);
				})
				.finally(() => {
					this.props.escondeAguardando();
				});
		}

		render() {
			return (
				<main id="content" className="page-content p-3">
					<Message />
					<Loading />
					<div style={{margin: "10px"}}>
						<h1>Solicitação de Cadastro de Arquivo Grandes Volumes</h1>
					</div>
					<div className="div-form">
						{this.state.executouCarregamento && this.renderForm()}
					</div>
				</main>
			);
		}

		renderForm() {
			const solicitacao = this.state.solicitacao;
			return(
				<div className="container-fluid">
					<ArquivoGrandesVolumesDetails solicitacao={solicitacao} mostraDetalhesAprovacao={true}/>
					<SecureDirectoryConfiguration
						solicitacao={solicitacao}
						botoesHabilitados={this.state.botoesHabilitados}
						onChangeProperties={(nome, valor) => {
							const solicitacao = this.state.solicitacao;
							solicitacao[nome] = valor;
							this.setState({ solicitacao });
						}}
						alterarAndamentoConfiguracaoPastaSegura={() => this.alterarSolicitacao()}
						concluirConfiguracaoPastaSeguraSolicitacao={() => this.concluirSolicitacao()}
					/>
					<SolicitacaoArquivoGrandesVolumesAttachmentsAndHistory solicitacao={solicitacao} habilitaEdicaoAnexo={false}/>
				</div>
			);
		}

		executaAndamento (url, concluido, mensagemSucesso, mensagemErro) {
			const { solicitacao } = this.state;

			if (concluido) {
				solicitacao.implantacaoConcluida = true;
			} else {
				solicitacao.implantacaoConcluida = false;
			}
			
			const options = {
				method: 'put',
				url,
				data: { ...solicitacao },
			}

			api(options)
				.then(response => { 
					this.setState({
						solicitacao: response.data,
						pesquisaExecutada : true,
					}) 
					this.props.exibeMensagemSucesso(mensagemSucesso);
				})
				.catch(erro => {
					const msg = getMessagemErro(mensagemErro, erro);
					console.log(JSON.stringify(msg));
					this.props.exibeMensagemErro(msg.mensagem, msg.erros);
				})
				.then (() =>{
					this.setState({botoesHabilitados:true});
					this.props.escondeAguardando();
				});
		}

		alterarSolicitacao() {
			this.setState({botoesHabilitados:false});
			this.props.limpaMensagem();
			this.props.mostraAguardando();
			window.scrollTo(0, 0);
			const mensagemSucesso = "Pasta Segura alterada com sucesso.";
			const mensagemErro = "Não foi possível alterar a Pasta Segura.";
			const url = '/api/solicitacao-cadastro-arquivo-gv/configurar-pasta-segura';
			this.executaAndamento(url, false, mensagemSucesso, mensagemErro);
		}

		concluirSolicitacao() {
			this.setState({botoesHabilitados:false});
			this.props.limpaMensagem();
			this.props.mostraAguardando();
			window.scrollTo(0, 0);
			const mensagemSucesso = "Pasta Segura concluída com sucesso.";
			const mensagemErro = "Não foi possível concluir a pasta segura.";
			const url = '/api/solicitacao-cadastro-arquivo-gv/configurar-pasta-segura';
			this.executaAndamento(url, true, mensagemSucesso, mensagemErro);
		}
	}
	

) // redux
); // router